var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 168,
    viewBox: "0 0 180 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Recycle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 168
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recycle",
    clipPath: "url(#clip-Recycle)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(-859.846 -885.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M931.277,1016.236H882.7l-22.858-40,24.626-35.571-7.094-4.607,19.826-5.614,19.827-5.614,2.932,20.4,2.932,20.4-6.373-4.14-10.959,14.753h25.715l-8.572,20Z",
    transform: "translate(0 28.689)",
    fill: "#16d676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M907.441,929.889l-22.2-3.331,26.576-41.191,47.527,1.816,17.667,39.734,7.915-3.574-5.933,19.788-5.933,19.788L953.6,954.6l-19.46-8.323,7.111-3.21-6.919-17.112-14.07,21.807Z",
    transform: "translate(14.549 0)",
    fill: "#16d676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M987.089,1012.452l-43.262.239.3,8.454-15.973-13.017-15.973-13.018,15.023-14.1,15.023-14.1.266,7.594,18.371.512-14.754-21.062,21.3-4.455L978.869,931l27.869,39.783Z",
    transform: "translate(33.108 32.222)",
    fill: "#16d676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/Recycle.691a1540c564f440c036ce9a6b36df17.svg";
export { ForwardRef as ReactComponent };